import { Component, OnInit, ViewChild, HostBinding } from '@angular/core';
import { ChatService } from "../chat.service";
import { SignalRService } from 'app/shared/chat/signalRService.service';
import { chatboxManager } from '../aside-chat/aside-chat-boxes'
import { CurrentUser, ChatMensaje, Empleado } from 'app/core/model/trjireh-model';

declare var $: any;

@Component({
  selector: 'aside-chat,[aside-chat]',
  templateUrl: './aside-chat.component.html',
  styles: [`:host{display:block}`]
})
export class AsideChatComponent implements OnInit {

  @ViewChild('chatUsersList') chatUsersList;
  @HostBinding('class') classes = 'chat-users top-menu-invisible';
  @HostBinding('class.open') open = false;

  public filter = ''
  public users: Array<any> = [];
  public usuarios: Array<Empleado> = [];
  currentUser: CurrentUser = new CurrentUser();

  constructor(public chatService: ChatService,
    signalRService: SignalRService) { }

  ngOnInit() {
    // chatboxManager.setChatService(this.chatService);
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if (this.currentUser != null && this.currentUser != undefined) {
      this.chatService.GetChatUsuarios()
        .subscribe(resp => {
          if (resp.result == 200) {
            // this.usuarios = resp.data.usuarios;
            const usuarios = resp.data.usuarios;
            // console.log(usuarios);

            this.users.push({
              visible: true,
              idUsuario: 0,
              usuario: '*',
              nombre: 'A Todos',
              apellido: '',
              puesto: '',
              status: 'online',
              chatId: '',
              picture: 'assets/img/avatars/male.png'
            });

            for (let i = 0; i < usuarios.length; i++) {
              if (usuarios[i].claveUsuario != this.currentUser.claveUsuario) {
                let conectado = 'incognito';
                if (usuarios[i].conectado) {
                  conectado = 'online';
                }

                this.users.push({
                  visible: true,
                  idUsuario: usuarios[i].idUsuario,
                  usuario: usuarios[i].claveUsuario,
                  nombre: usuarios[i].nombre,
                  apellido: usuarios[i].apellido,
                  puesto: usuarios[i].puesto,
                  status: conectado,
                  chatId: '',
                  picture: 'assets/img/avatars/male.png'
                });
              }
            }
          }
        });
    }

    // this.chatService.getChatState().subscribe((state) => {
    //   this.users = state.users.map((it) => {
    //     it.visible = true;
    //     return it
    //   });
    // });

    // subscripcion para enviar mensaje al servidor
    this.chatService.messageSended.subscribe((mensaje) => {

      const msg: ChatMensaje = new ChatMensaje();
      msg.toUsuario = mensaje.toUsuario;
      msg.fromUsuario = this.currentUser.claveUsuario;
      msg.mensaje = mensaje.mensaje;

      this.chatService.EnviarMensaje(msg)
        .subscribe(resp => {
          if (resp.result == 200) {
            // console.log('');
          }
        });
    });
  }

  onFilter() {
    this.users.forEach((it) => {
      if (!this.filter) {
        it.visible = true
      } else {
        it.visible = it.nombre.toLowerCase().indexOf(this.filter.toLocaleLowerCase()) > -1;
      }

    })
  }

  openToggle(e) {
    this.open = !this.open
    $(this.chatUsersList.nativeElement).slideToggle();
    e.preventDefault()
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/chat/aside-chat/aside-chat.component.ts